export default __webpack_public_path__ + "static/media/Arrow.be06dee5.svg";